import axiosClient from './axiosClient';

export const getDetailExpert = (param?: any): Promise<any> => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/expert?title=Expert - ${param}`;
    return axiosClient.get(url);
};
